// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $(document).on('click', '.openMenu', function (e) {
            e.preventDefault();
            $('body').addClass('activeMenu');
        });

        $(document).on('click', '.closeMenu', function (e) {
            e.preventDefault();
            $('body').removeClass('activeMenu');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });
        // AOS.init({ disable: 'mobile' });

        if ($('.homeReal__slider').length) {
            $('.homeReal__slider').slick({
                slidesToShow: 3,
                autoplay: true,
                autoplaySpeed: 4000,
                infinite: true,
                lazyLoad: "progressive",
                speed: 800,
                arrows: true,
                dots: false,
                draggable: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }
        setTimeout(function () {
            if ($('.sf-input-select').length) {
                $('.sf-input-select').addClass('form-select');
            }
        }, 1000);

        const showModal = setTimeout(function() {
            const modalKey = 'modal_last_closed';

            // Lấy thời gian hiện tại
            const now = new Date().getTime();

            // Kiểm tra localStorage
            const lastClosed = localStorage.getItem(modalKey);

            if(!lastClosed || now - lastClosed > 3600000) {
                $('#modalRegister').modal('show');

                $(document).on('hidden.bs.modal', function() {
                    localStorage.setItem(modalKey, new Date().getTime());
                });
            }
        }, 3000);
    });

})(jQuery)